import React, { useEffect, useState, useContext } from 'react';
import { Button, Dimmer, Loader } from 'semantic-ui-react';
import UserContext from '../../../contexts/UserContext';
import './style.less';
import 'react-phone-number-input/style.css';
import { getRelatedRegistrants } from '../../../services/db';
import { Redirect } from 'react-router-dom';

interface MessageRecipient {
    _id: string;
    FirstName: string;
    LastName: string;
    Image: string;
    manager?: boolean;
    Email?: string;
    Phone?: string;
}

const MessageRecipients = (props) => {
    const [loading, setLoading] = useState(false);

    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    return (
        <div>
            <div className="pb-70">
                <div className="relative-list">
                    {loading ? (
                        <Dimmer className="mt-80" active={loading} inverted>
                            <Loader active={loading} />
                        </Dimmer>
                    ) : listOfResidents && activeRegistrantsIndexes.length ? (
                        <Redirect
                            to={`/message-recipients/${
                                (listOfResidents[activeRegistrantsIndexes] &&
                                    listOfResidents[activeRegistrantsIndexes]._id) ||
                                listOfResidents[0]._id
                            }`}
                        />
                    ) : (
                        <>
                            <div className="no-message-recipients">
                                You have not added an Alexa User to your account. Invite an Alexa User by clicking “Add
                                New” or “Invite New” below.
                            </div>
                            <div className="buy-container">
                                <Button
                                    className="primary large basic"
                                    onClick={() => props.history.push('/message-recipients/create')}
                                >
                                    <i className="plus circle icon"></i> Add New Alexa User
                                </Button>
                                <Button
                                    className="primary large basic invite-alexa-user-button"
                                    onClick={() => props.history.push('/invite-alexa-user')}
                                >
                                    <i className="plus circle icon"></i> Invite New Alexa User
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MessageRecipients;
